import axios from "axios";

const REACT_APP_MICRO_CHAT_URL = process.env.REACT_APP_MICRO_CHAT_URL;

export const getMessagesOpenedThread = (id) => (dispatch) => {
  axios
    .get(`${REACT_APP_MICRO_CHAT_URL}/messages/thread_opened/${id}`)
    .then((response) => {
      dispatch({
        type: "GET_MESSAGE_BY_OPENED_THREAD_ID",
        data: response.data.data,
      });
    });
};
export const getMessagesByThreadId = (id) => (dispatch) => {
  axios
    .get(`${REACT_APP_MICRO_CHAT_URL}/messages/thread/${id}`)
    .then((response) => {
      dispatch({
        type: "GET_MESSAGE_BY_THREAD_ID_SUCCESS",
        data: response.data.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: "GET_MESSAGE_BY_THREAD_ID_FAILED",
        payload: err.response,
      });
    });
};
export const getSearchMessagesByThreadId = (id, search) => (dispatch) => {
  axios
    .get(
      `${REACT_APP_MICRO_CHAT_URL}/messages/thread/_search/${id}?search=${search}`
    )
    .then((response) => {
      dispatch({
        type: "GET_SEARCH_MESSAGE_BY_THREAD_ID_SUCCESS",
        data: response.data.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: "GET_SEARCH_MESSAGE_BY_THREAD_ID_FAILED",
        payload: err.response,
      });
    });
};
export const getMessagesByParticipantByThreadId = (id) => (dispatch) => {
  axios
    .get(`${REACT_APP_MICRO_CHAT_URL}/messages/participant/${id}`)
    .then(() => {
      dispatch({
        type: "GET_MESSAGE_BY_THREAD_PARTICIPANT_ID_SUCCESS",
      });
    })
    .catch((err) => {
      dispatch({
        type: "GET_MESSAGE_BY_THREAD_PARTICIPANT_ID_FAILED",
        payload: err.response,
      });
    });
};
export const insertMessage = (data, func) => (dispatch) => {
  const forData = new FormData();
  forData.append("owner", data.owner);
  forData.append("body", data.body);
  forData.append("type", data.type);
  axios
    .post(`${REACT_APP_MICRO_CHAT_URL}/messages`, forData)
    .then(() => {
      dispatch({
        type: "INSERT_MESSAGE_SUCCESS",
      });
      func();
    })
    .catch((err) => {
      err.response?.data &&
        dispatch({
          type: "INSERT_MESSAGE_FAILED",
          payload: err.response.data.message,
        });
      setTimeout(() => {
        dispatch({
          type: "INSERT_MESSAGE_FAILED",
          payload: null,
        });
      }, 5000);
    });
};
